import type {
  IBillingProfileDataWeb,
  IBillingProfileData,
  IUpdateBillingProfileBody,
  BillingCustomerType,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

/** Update the billing profile associated with a customer in BillingPlatform.
 * Optionally indicate whether this was triggered by a customer making a payment. */
export const updateBillingProfile = async ({
  billingProfile,
  logNewPayment,
  billingCustomerType,
  customerId,
}: {
  billingProfile: IBillingProfileData;
  logNewPayment?: boolean;
  billingCustomerType?: BillingCustomerType;
  customerId?: string;
}): Promise<IBillingProfileDataWeb> => {
  const { data } = await axios.post<
    IBillingProfileDataWeb,
    AxiosResponse<IBillingProfileDataWeb>,
    IUpdateBillingProfileBody
  >('/billing/billing_profile/', {
    billingProfile,
    logNewPayment,
    billingCustomerType,
    customerId,
  });
  return data;
};
